import Command from '@ckeditor/ckeditor5-core/src/command';

export default class makeCommentCommand extends Command {
    execute() {
        this.editor.model.change( writer => {

            const start = this.editor.model.document.selection.getFirstPosition();
            const end = this.editor.model.document.selection.getLastPosition();

            const range = writer.createRange( start, end );

            let rdm = 'comment:' + Math.floor( Math.random() * 100 ) + ':' + 'cxlls';

            const marker = writer.addMarker( rdm, { range, usingOperation: true } );

            // console.log( this.editor.model.markers )

            // writer.removeMarker( marker );

        });
    }
}